"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("@pbl/pbl-react-core/lib/models/draws/types");
var games_1 = require("@pbl/pbl-react-core/lib/models/games");
var action_type_util_1 = require("../../action-type.util");
var INITIAL_DRAW_DETAIL_STATE = {
    loading: false,
    draw: null,
    latestDrawHistory: null,
    drawHistoryRetrieved: false,
    drawPrizes: [],
    prizes: [],
    drawPrizeContentRetrieved: false,
    drawPrizesWithWinners: [],
    drawPrizeWinnersRetrieved: false,
    eligibleGames: new games_1.GamesList(),
    giveawayDraw: null,
    giveawayEntries: 0
};
exports.default = (function (state, action) {
    if (state === void 0) { state = INITIAL_DRAW_DETAIL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(types_1.FETCH_ELIGIBLE_GAMES):
        case (0, action_type_util_1.REQUEST)(types_1.GET_GIVEAWAY_PROMOTION_ENTRIES_DETAILS):
            return __assign(__assign({}, state), { eligibleGames: new games_1.GamesList() });
        case types_1.SELECT_DRAW:
            return __assign(__assign({}, state), { draw: action.payload.draw, latestDrawHistory: null, drawHistoryRetrieved: !action.payload.isDrawEnded, drawPrizes: [], drawPrizeContentRetrieved: false, drawPrizesWithWinners: [], drawPrizeWinnersRetrieved: false });
        case types_1.SELECT_GIVEAWAY_DRAW:
            return __assign(__assign({}, state), { giveawayDraw: action.payload.draw, latestDrawHistory: null, drawHistoryRetrieved: !action.payload.isDrawEnded, drawPrizes: [], drawPrizeContentRetrieved: false, drawPrizesWithWinners: [], drawPrizeWinnersRetrieved: false });
        case (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAW_WITH_ADDITIONAL_INFORMATION):
        case (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAW_PRIZES):
        case (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAW_PRIZES_WITH_CONTENT):
        case (0, action_type_util_1.REQUEST)(types_1.FETCH_LATEST_DRAW_HISTORY):
        case (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAW_PRIZES_WITH_WINNERS):
            return __assign(__assign({}, state), { loading: true });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAW_WITH_ADDITIONAL_INFORMATION):
            return __assign(__assign({}, state), { loading: false, draw: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_1.GET_GIVEAWAY_PROMOTION_ENTRIES_DETAILS):
            return __assign(__assign({}, state), { giveawayEntries: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAW_PRIZES):
            return __assign(__assign({}, state), { loading: false, errorMessage: '', drawPrizes: action.payload, drawPrizeContentRetrieved: false });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAW_PRIZES_WITH_CONTENT):
            return __assign(__assign({}, state), { loading: false, errorMessage: '', drawPrizes: action.payload.prizesWithContent, prizes: action.payload.prizes, drawPrizeContentRetrieved: true });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_LATEST_DRAW_HISTORY):
            return __assign(__assign({}, state), { loading: false, errorMessage: '', drawHistoryRetrieved: true, latestDrawHistory: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAW_PRIZES_WITH_WINNERS):
            return __assign(__assign({}, state), { loading: false, errorMessage: '', drawPrizesWithWinners: action.payload, drawPrizeWinnersRetrieved: true });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAW_ENTRY_DETAILS):
            return __assign(__assign({}, state), { entries: action.payload.totalActiveEntries !== undefined
                    ? action.payload.totalActiveEntries
                    : action.payload.totalPrizeAmount
                        ? action.payload.totalPrizeAmount
                        : 0, optOutEntries: action.payload.totalOptOutEntries ? action.payload.totalOptOutEntries : 0, loading: false });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_ELIGIBLE_GAMES):
            return __assign(__assign({}, state), { eligibleGames: action.payload });
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAW_WITH_ADDITIONAL_INFORMATION):
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAW_PRIZES):
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAW_PRIZES_WITH_CONTENT):
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAW_PRIZES_WITH_WINNERS):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload, drawHistoryRetrieved: true });
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_LATEST_DRAW_HISTORY):
            return __assign(__assign({}, state), { loading: false, errorMessage: '', drawHistoryRetrieved: true });
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_ELIGIBLE_GAMES):
            return __assign(__assign({}, state), { eligibleGames: new games_1.GamesList() });
        case (0, action_type_util_1.FAILURE)(types_1.GET_GIVEAWAY_PROMOTION_ENTRIES_DETAILS):
            return __assign(__assign({}, state), { errorMessage: action.payload.title });
        default:
            return state;
    }
});
//# sourceMappingURL=draw-detail.reducer.js.map